<script setup>
import {computed, defineEmits, defineProps, ref} from "vue";
import {game} from "@/utils/config";
import store from "@/store";
import router from "@/router";

// const data = ref({});
const type = computed(() => game.qxdj)
const props = defineProps({
  productLst: {
    type: Array,
    default() {
      return []
    }
  },
  account: {
    type: Object,
    default() {
      return {}
    }
  }
})

const emit = defineEmits(['login', 'checked'])

const categoryAct = ref(0);
const product = computed(() => {
  let plate = categoryAct.value === 0 ? "家政保洁" : "优惠券"
  let _data = props.productLst.filter(i => i.plate === plate)
  return _data.map(i => {
    if (i.remarks.length)
      i.remarks = JSON.parse(i.remarks || '{}')
    return i
  })
})

const changeCoup = inx => {
  categoryAct.value = inx
}

const details = i => {
  // emit('login', i)
  store.commit("setProduct", i)
  router.push({name: "detail"})
}
</script>

<template>
  <div class="product-lst">
    <div class="product-header">
      <div class="bottom-header">
        <el-image :src="type.headerImg"/>
      </div>
    </div>
    <div class="qxdj-category">
      <div class="qxdj-category-items " :class="{'qxdj-category-active': categoryAct === 0}" @click="changeCoup(0)">
        家政保洁
      </div>
      <div class="qxdj-category-items" :class="{'qxdj-category-active': categoryAct === 1}" @click="changeCoup(1)">
        优惠券
      </div>
    </div>
    <div class="product-lst-items">
      <div v-for="(i,inx) in product" :key="inx">
        <div class="product-lst-info" v-if="categoryAct === 1" :style="{backgroundImage: `url('${type.productImg}')`}">
          <div class="product-price">
            <div class="face-value">
              <sup class="unit">￥</sup>{{ parseFloat(i.face_value) }}
            </div>
            <div class="tips">无门槛使用</div>
          </div>
          <div class="product-lst-values">
            <div class="product-values">
              <p>{{ type.name }}</p>
              <p>{{ type.coupon_type }}</p>
            </div>
            <div class="change-data">
              <div class="pay-miles">
                <span class="miles">{{ i.mileTypes.scal.total }}</span><span class="miles-unit">里程</span>
              </div>
              <div class="pay-btn">
                <el-button type="danger" round v-if="Object.keys(props.account).length < 1"
                           @click="emit('login',i)" class="pay-success">
                  立即兑换
                </el-button>
                <el-button type="danger" round
                           v-else-if="Object.keys(props.account).length && parseInt(props.account.balance_miles) >= parseInt(i.mileTypes.scal.total)"
                           @click="emit('checked',i)" class="pay-success">
                  立即兑换
                </el-button>
                <el-button type="info" round v-else class="pay-fail">可用里程不足</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="product-cat" v-else>
          <div class="product-its">
            <div class="product-cat-title">
              <el-image :src="i.remarks?.coupon_discount_icon" v-if="i.remarks?.coupon_discount_icon"/>
              <div class="product-cat-title-name"><b>{{ i?.goods_name }}</b></div>
            </div>
            <div class="product-jingle-tip">
              {{ i?.active_tips }}
            </div>
            <div class="product-cat-jingle">
              <div class="product-cat-jingle-left">
                <div class="pay-miles">
                  <span class="miles">{{ i.mileTypes.scal.total }}</span><span class="miles-unit">里程</span>
                </div>
                <div class="face-value">
                  原价:￥{{ parseFloat(i.face_value) }}
                </div>
              </div>
              <div class="pay-btn">
                <el-button type="danger" round class="pay-success" @click="details(i)">
                  立即兑换
                </el-button>
              </div>
            </div>
          </div>
          <div class="icon">
            <el-image :src="i.product_img" v-if="i.product_img"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.product-lst {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: var(--el-box-shadow);
  padding: 10px;
  border-radius: 12px;
  position: relative;

  .product-lst-items {
    margin-top: 15px;

    .product-lst-info {
      box-sizing: border-box;
      padding: 5px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      height: 100px;
      margin-bottom: 10px;
      position: relative;

      .product-price {
        text-align: center;
        flex-basis: 100px;
        width: 100px;
        color: var(--view-product-lst-border-color);
        position: relative;

        .face-value {
          font-size: 1.65rem;
          font-weight: 600;
          position: absolute;
          left: 0;
          right: 0;
          top: 50%;
          height: 40px;
          margin-top: -30px;

          .unit {
            font-size: .85rem;
            margin-top: 10px;
            display: inline-block;
          }
        }

        .tips {
          position: absolute;
          font-size: .65rem;
          left: 0;
          right: 0;
          text-align: center;
          bottom: 5px;
        }
      }

      .product-lst-values {
        flex-basis: calc(100% - 100px);
        box-sizing: border-box;
        padding: 10px 20px;
        line-height: 1.75;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .product-values {
          color: var(--view-product-lst-border-color);
          font-weight: 500;
        }

        .change-data {
          text-align: center;
        }


      }
    }

    .product-cat {
      background: #F0F1FF;
      box-sizing: border-box;
      //padding: 10px;
      margin-bottom: 10px;
      border-radius: 12px;
      border: 1px solid #002FA9;
      display: flex;
      justify-content: space-between;
      align-items: stretch;

      .product-its {
        box-sizing: border-box;
        padding: 10px 0 10px 10px;
        flex-basis: calc(100% - 70px);
        width: calc(100% - 70px);
        line-height: 25px;

        .product-cat-title {
          display: flex;
          align-items: center;
          gap: 5px;
          //margin-bottom: 10px;
          .el-image {
            flex-basis: 65px;
            width: 65px;
            height: 20px;
          }

          .product-cat-title-name {
            font-size: .85rem;
            color: #002FA9;
          }
        }

        .product-jingle-tip {
          color: var(--el-color-info);
          font-size: .8rem;
        }

        .product-cat-jingle {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .product-cat-jingle-left {
            flex-basis: calc(100% - 100px);
            width: calc(100% - 100px);
            display: flex;
            align-items: flex-end;
            justify-content: space-between;

            .face-value {
              font-size: .8rem;
              //删除线
              text-decoration: line-through;
              color: var(--el-color-info);
            }
          }
        }
      }


      .icon {
        flex-basis: 70px;
        width: 70px;
        position: relative;
        .el-image{
          position: absolute;
          bottom: 0;
        }
      }
    }
  }
}

.product-header {
  position: absolute;
  top: -18px;
  z-index: 999;
  left: 0;
  right: 0;
  height: 45px;
  text-align: center;
  line-height: 45px;
  font-size: 1.33rem;
  color: #ffffff;
  font-weight: 600;
  background-image: url("@/assets/images/qxdj/header-bottom.png");
  background-position: center 6px;
  background-repeat: no-repeat;
  background-size: 220px auto;

  .bottom-header {
    width: 220px;
    margin: 6px auto;
  }
}

.qxdj-category {
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  white-space: nowrap;
  position: relative;
  z-index: 999;

  .qxdj-category-items {
    padding: 3px 15px;
    border: 1px solid #002FA9;
    border-radius: 45px;
    color: #002FA9;

    &.qxdj-category-active {
      background-color: #002FA9;
      color: #ffffff;
    }
  }
}

.pay-btn {
  .el-button {
    border: 0;
    position: relative;

    &.pay-success {
      background: var(--view-product-value-background-color);
    }

    &.pay-fail {
      background: var(--view-product-value-background-fail-color);
    }
  }
}

.pay-miles {
  font-size: .65rem;
  white-space: nowrap;

  .miles {
    font-size: 1.25rem;
    color: var(--view-product-lst-border-color);
  }
}
</style>
